import { AnimatePresence, motion, useReducedMotion } from "framer-motion";

const NAVY = "18,35,74";
export const TEXT_SHADOW = {
  soft: "0 2px 12px rgba(0,0,0,.45)",
  strong: "0 2px 4px rgba(0,0,0,.7), 0 4px 24px rgba(0,0,0,.6)",
};
export const shadowStyle = (v) => (TEXT_SHADOW[v] ? { textShadow: TEXT_SHADOW[v] } : undefined);
export const POS_CLASS = { top: "self-start", center: "self-center", bottom: "self-end" };

// Background photo + overlay for the current slide; crossfades when the photo changes.
export function HeroBackdrop({ src, mobileSrc, focus, overlay, zoom, phone }) {
  const still = useReducedMotion();
  const z = zoom && !still;
  const custom = overlay != null && overlay >= 0;
  const a = (overlay ?? 0) / 100;
  return (
    <>
      <AnimatePresence initial={false}>
        <motion.div key={`${src}|${mobileSrc || ""}|${z ? "z" : "s"}`} initial={{ opacity: 0, scale: 1 }} animate={{ opacity: custom ? 1 : 0.25, scale: z ? 1.12 : 1 }} exit={{ opacity: 0 }}
          transition={{ opacity: { duration: 0.9, ease: "easeInOut" }, scale: z ? { duration: 18, ease: "linear", repeat: Infinity, repeatType: "reverse" } : { duration: 0 } }}
          className="absolute inset-0 will-change-transform" data-testid="hero-bg-layer" data-zoom={z ? "on" : "off"}>
          <picture>
            {mobileSrc && <source media="(max-width: 639px)" srcSet={mobileSrc} />}
            <img src={src} alt="" style={phone ? { objectPosition: focus || "50% 50%" } : { "--fp": focus || "50% 50%" }} data-testid={phone ? "hero-phone-bg-img" : "hero-bg-img"}
              className="w-full h-full object-cover max-sm:[object-position:var(--fp)]" />
          </picture>
        </motion.div>
      </AnimatePresence>
      <div className="absolute inset-0 transition-[background] duration-700" data-testid="hero-overlay"
        style={{ background: custom
          ? `linear-gradient(to right, rgba(${NAVY},${Math.min(1, a + 0.1)}), rgba(${NAVY},${a * 0.9}) 50%, rgba(${NAVY},${a * 0.45}))`
          : `linear-gradient(to right, rgb(${NAVY}), rgba(${NAVY},.9) 50%, rgba(${NAVY},.4))` }} />
    </>
  );
}
